import * as React from "react";
const SvgArrowLeftFlat = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 171 150", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#14387f", d: "M70.2 141.2L84.5 127 42.3 85h124.6l-.1-20H42.3l42.2-42L70.2 8.8 4.2 75z" }));
export default SvgArrowLeftFlat;
